import React from "react";
import { getValue } from "@utils/lodash";

function EditGreySvgComponent(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
        height={
            getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        width={
            getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        viewBox="0 0 24 24">
        <defs>
            <clipPath id="clip-path-edit-grey">
            <rect id="Rectangle_18170" data-name="Rectangle 18170" width="24" height="24" transform="translate(-10487 -7032)" fill="#fff"/>
            </clipPath>
        </defs>
        <g id="Mask_Group_278" data-name="Mask Group 278" transform="translate(10487 7032)" clip-path="url(#clip-path-edit-grey)">
            <path id="edit_FILL0_wght300_GRAD0_opsz24" d="M6.529-12.529H7.865L18.7-23.368,17.368-24.7,6.529-13.865ZM4.941-10.941v-3.584l13.966-13.96a1.8,1.8,0,0,1,.53-.337,1.589,1.589,0,0,1,.609-.119,1.728,1.728,0,0,1,.617.113,1.392,1.392,0,0,1,.529.359l1.293,1.309a1.311,1.311,0,0,1,.351.53,1.8,1.8,0,0,1,.1.6,1.718,1.718,0,0,1-.109.61,1.5,1.5,0,0,1-.347.53L8.525-10.941H4.941ZM21.363-26.034l-1.33-1.33Zm-3.339,2.009-.656-.68L18.7-23.368Z" transform="translate(-10488.941 -7000.059)" fill={
        getValue(props, `color`, "") ? getValue(props, `color`, "") : "#5f6368"
    } />
        </g>
    </svg>

  );
}

export default EditGreySvgComponent;
